import {
	Box,
	Button,
	CircularProgress,
	Divider,
	FormControl,
	Grid,
	IconButton,
	InputAdornment,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	Stack,
	TextField,
	Typography,
	useTheme,
} from "@mui/material";
import axios from "axios";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import InputMask from "react-input-mask";
import { NumericFormat } from "react-number-format";
import { useOutletContext, useBlocker } from "react-router-dom";
import { set, z } from "zod";
import api from "../../../services/api";
import useStyles from "./styles";
import {
	ApartmentOutlined,
	DeleteOutlineOutlined,
	Home,
	PeopleOutlineOutlined,
	Phone,
} from "@mui/icons-material";
import { maskCnpj } from "../../../utils/masks";
import InternoModalConfirmacaoSaida from "../../../components/modalSaindoDaPagina";
import TagCliente from "../../../components/tagCliente";
import TagSelector from "../acessos/tagSelectorComponent";

function NumberFormatCustom(props) {
	const { inputRef, onChange, ...other } = props;

	return (
		<NumericFormat
			{...other}
			getInputRef={inputRef}
			onValueChange={(values) => {
				onChange({
					target: {
						value: values.value,
					},
				});
			}}
			thousandSeparator={"."}
			decimalSeparator={","}
		/>
	);
}

NumberFormatCustom.propTypes = {
	inputRef: PropTypes.func.isRequired,
	onChange: PropTypes.func.isRequired,
};

const businessDataSchema = z.object({
	cnpj: z.string().min(1, "CNPJ é obrigatório"),
	razaoSocial: z.string().min(1, "Razão Social é obrigatório"),

	// as: z.string().min(1, "ASN é obrigatório"),
});

const cnpjSchema = z.string().regex(/^\d{14}$/, "CNPJ inválido");
const cepSchema = z.string().regex(/^\d{5}-\d{3}$/, "CEP inválido");
const telefoneSchema = z
	.string()
	.regex(/^\(\d{2}\) \d{4}-\d{4}$/, "Telefone inválido");
const celularSchema = z
	.string()
	.regex(/^\(\d{2}\) \d{5}-\d{4}$/, "Telefone inválido");
const emailSchema = z.string().email("Email inválido");

export default function InternoPerfilCliente() {
	const [
		setSnackbar,
		clienteInfo,
		setClienteInfo,
		changedPerfil,
		searchTerm,
		setSearchTerm,
		setChangedPerfil,
		serviceFilter,
		setServiceFilter,
		services,
		setServices,
		setValue,
	] = useOutletContext();
	const theme = useTheme();
	const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;
	const styles = useStyles(theme);
	const [errors, setErrors] = useState({});
	const [errorSearch, setErrorSearch] = useState(false);
	const [loadingGetCEP, setLoadingGetCEP] = useState();
	const [editMode, setEditMode] = useState(false);
	const [tagsProduto, setTagsProduto] = useState(clienteInfo?.tagsCliente || []);
	const [loading, setLoading] = useState(false);
	const [loadingASN, setLoadingASN] = useState(false);
	const [checouAs, setChecouAs] = useState(true);
	const [showSearchBox, setShowSearchBox] = useState(false);
	const [loadingFindClient, setLoadingFindClient] = useState(false);
	const [paramsSearchCliente, setParamsSearchCliente] = useState({
		params: "",
		typeSearch: 1,
	});
	const [clientesRelacionadosChange, setClientesRelacionadosChange] = useState(
		[],
	);
	const [clientesRelacionados, setClientesRelacionados] = useState([]);

	const [formData, setFormData] = useState({
		cnpj: clienteInfo?.cnpj || "",
		razaoSocial: clienteInfo?.razaoSocial || "",
		nomeFantasia: clienteInfo?.nomeFantasia || "",
		as: clienteInfo?.as || "",
		cep: clienteInfo?.clientesCadastro?.cep || "",
		estado: clienteInfo?.clientesCadastro?.estado || "",
		cidade: clienteInfo?.clientesCadastro?.cidade || "",
		bairro: clienteInfo?.clientesCadastro?.bairro || "",
		logradouro: clienteInfo?.clientesCadastro?.logradouro || "",
		numero: clienteInfo?.clientesCadastro?.numero || "",
		complemento: clienteInfo?.clientesCadastro?.complemento || "",
		telefone: clienteInfo?.clientesCadastro?.telefone || "",
		email: clienteInfo?.clientesCadastro?.email || "",
		plano: clienteInfo?.clientesCadastro?.plano || "",
		diaDePagamento: clienteInfo?.clientesCadastro?.diaDePagamento || "",
		valor: clienteInfo?.clientesCadastro?.valor || "",
		reajuste: clienteInfo?.clientesCadastro?.reajuste || "",
	});

	// Confirmação ao sair da página
	const [confirmacaoSaidaPagina, setConfirmacaoSaidaPagina] = useState(false);
	const [changed, setChanged] = useState(false);
	const blocker = useBlocker(({ currentLocation, nextLocation }) => {
		return (
			currentLocation.pathname !== nextLocation.pathname &&
			!!editMode &&
			!!changed
		);
	});
	// Mostra modal quando bloquear e marca que é navegação de rota
	useEffect(() => {
		if (blocker?.state === "blocked") {
			setConfirmacaoSaidaPagina(true);
		}
	}, [blocker?.state]);
	// Bloquear recarregar página, fechar aba, etc.
	useEffect(() => {
		const handleBeforeUnload = (e) => {
			if (changed) {
				e.preventDefault();
				e.returnValue = ""; // Requerido por todos os browsers modernos
			}
		};
		window.addEventListener("beforeunload", handleBeforeUnload);
		return () => {
			window.removeEventListener("beforeunload", handleBeforeUnload);
		};
	}, [changed]);

	useEffect(() => {
		setFormData({
			cnpj: clienteInfo?.cnpj || "",
			razaoSocial: clienteInfo?.razaoSocial || "",
			nomeFantasia: clienteInfo?.nomeFantasia || "",
			as: clienteInfo?.as || "",
			cep: clienteInfo?.clientesCadastro?.cep || "",
			estado: clienteInfo?.clientesCadastro?.estado || "",
			cidade: clienteInfo?.clientesCadastro?.cidade || "",
			bairro: clienteInfo?.clientesCadastro?.bairro || "",
			logradouro: clienteInfo?.clientesCadastro?.logradouro || "",
			numero: clienteInfo?.clientesCadastro?.numero || "",
			complemento: clienteInfo?.clientesCadastro?.complemento || "",
			telefone: clienteInfo?.clientesCadastro?.telefone || "",
			email: clienteInfo?.clientesCadastro?.email || "",
			plano: clienteInfo?.clientesCadastro?.plano || "",
			diaDePagamento: clienteInfo?.clientesCadastro?.diaDePagamento || "",
		});
		setValues({
			valor: clienteInfo?.clientesCadastro?.valor || "",
			reajuste: clienteInfo?.clientesCadastro?.reajuste || "",
		});
		setClientesRelacionadosChange(clienteInfo?.ClientesRelacionados || []);
		setClientesRelacionados(clienteInfo?.ClientesRelacionados || []);
		setTagsProduto(clienteInfo?.tagsCliente || []);
	}, [clienteInfo]);

	const [values, setValues] = useState({
		valor: clienteInfo?.clientesCadastro?.valor || "",
		reajuste: clienteInfo?.clientesCadastro?.reajuste || "",
	});

	async function getCEP(cep) {
		try {
			setLoadingGetCEP(!editMode);
			const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
			const { uf, localidade, bairro, logradouro } = response.data;
			setFormData((prev) => ({
				...prev,
				estado: uf,
				cidade: localidade,
				bairro,
				logradouro,
			}));
			handleBlur({ target: { name: "estado", value: uf } });
			handleBlur({ target: { name: "cidade", value: localidade } });
			handleBlur({ target: { name: "bairro", value: bairro } });
			handleBlur({ target: { name: "logradouro", value: logradouro } });
		} catch (error) {
			console.error(error);
		} finally {
			setLoadingGetCEP(false);
		}
	}

	async function validarAs(as) {
		try {
			setLoadingASN(!editMode);
			//Checa se é vazio
			if (as?.trim() === "") {
				throw new Error("ASN não encontrado");
			}
			const response = await axios.get(
				"https://stat.ripe.net/data/as-overview/data.json",
				{
					params: {
						resource: as,
					},
				},
			);

			if (!response?.data?.data?.announced) {
				throw new Error("ASN não encontrado");
			}
			//sucesso
		} catch (error) {
			console.error(error);
			setErrors((prev) => ({
				...prev,
				as:
					error?.message === "ASN não encontrado"
						? error?.message
						: "ASN inválido",
			}));
		} finally {
			setLoadingASN(false);
			setChecouAs(true);
		}
	}

	function handleInputChange(e) {
		const { name, value } = e.target;
		setChanged(true);
		if (name === "as") {
			// impede submit sem checar validade do as
			setChecouAs(false);
			// permite apenas numeros
			const regexNums = /\d+/g;
			const nums = value?.match(regexNums)?.join("") || "";
			setFormData((prev) => ({ ...prev, [name]: nums }));
		} else {
			setFormData((prev) => ({ ...prev, [name]: value }));
		}
		if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
	}

	function handleBlur(e) {
		const { name, value } = e.target;
		try {
			if (name === "cnpj") {
				cnpjSchema.parse(value.replace(/[^\d]/g, ""));
			} else if (name === "cep") {
				cepSchema.parse(value);
				getCEP(value);
			} else if (name === "telefone") {
				value?.replace(/\s+/g, "")?.length === 13
					? telefoneSchema.parse(value.trim())
					: celularSchema.parse(value);
			} else if (name === "email") {
				emailSchema.parse(value);
			} else if (name === "as") {
				validarAs(value);
			}
			setErrors((prev) => ({ ...prev, [name]: "" }));
		} catch (err) {
			setErrors((prev) => ({ ...prev, [name]: err.errors[0].message }));
		}
	}

	function changeEditMode() {
		setEditMode(!editMode);
	}

	async function handleUpdateCadastro() {
		setLoading(true);

		try {
			//Validação zod
			businessDataSchema.parse({
				cnpj: formData?.cnpj,
				razaoSocial: formData?.razaoSocial,

				as: formData?.as,
			});
			//checa validade do as
			// handleBlur({ target: { name: "as", value: formData?.as } });

			if (checouAs) {
				const response = await api.put("/updateCliente", {
					id: clienteInfo?.id,
					cnpj: formData?.cnpj,
					razaoSocial: formData?.razaoSocial,
					nomeFantasia: formData?.nomeFantasia,
					as: formData?.as,
					cep: formData?.cep,
					estado: formData?.estado,
					cidade: formData?.cidade,
					bairro: formData?.bairro,
					logradouro: formData?.logradouro,
					numero: formData?.numero,
					complemento: formData?.complemento,
					telefone: formData?.telefone,
					email: formData?.email,
					plano: formData?.plano,
					diaDePagamento: formData?.diaDePagamento?.toString() || "",
					valor: parseFloat(values?.valor),
					reajuste: parseFloat(values?.reajuste),
					clientesRelacionados: clientesRelacionadosChange,
				});

				// Produto (tag de cliente) salva junto da edicao do cadastro - grupo economico nao tem produto
				const respostaTags = clienteInfo?.isGrupoEconomico
					? null
					: await api.post("/update/tags/cliente", {
							clienteId: clienteInfo?.id,
							tagIds: tagsProduto.map((tag) => tag?.id),
						});

				//on success
				setClienteInfo({
					...response?.data,
					tagsCliente: respostaTags?.data?.tagsCliente ?? clienteInfo?.tagsCliente,
				});

				setEditMode(false);

				setErrors({});
				setSnackbar({
					children: "Cadastro editado com sucesso!",
					severity: "success",
				});
			}
			setChanged(false);
		} catch (error) {
			console.error(error);
			const newErrors = {};
			error?.errors?.forEach((err) => {
				newErrors[err.path[0]] = err.message;
			});
			setErrors(newErrors);
			setSnackbar({
				children: "Error: Não foi possivel se conectar ao servidor",
				severity: "error",
			});
		} finally {
			setLoading(false);
		}
	}

	const getSearchValidation = (
		paramsSearchCliente,
		clienteInfo,
		errorSearch,
	) => {
		const raw = paramsSearchCliente?.params?.trim() || "";
		const onlyNumbers = raw.replace(/\D/g, "");

		// --- 1) Campo vazio ---
		if (errorSearch && !raw) {
			return {
				error: true,
				message:
					paramsSearchCliente?.typeSearch === 1
						? "Necessário informar o CNPJ"
						: "Necessário informar o Código cliente",
			};
		}

		// --- 2) CNPJ já pertence ao perfil ---
		if (
			paramsSearchCliente?.typeSearch === 1 &&
			onlyNumbers === clienteInfo?.cnpj?.trim()?.replace(/\D/g, "")
		) {
			return {
				error: true,
				message: "Esse cliente já pertence a esse perfil",
			};
		}

		// --- 3) Código cliente já pertence ao perfil ---
		if (
			paramsSearchCliente?.typeSearch === 2 &&
			onlyNumbers === clienteInfo?.clienteErpId
		) {
			return {
				error: true,
				message: "Esse cliente já pertence a esse perfil",
			};
		}

		// --- 4) Verificar duplicidade em clientesRelacionadosChange ---
		if (
			Array.isArray(clientesRelacionadosChange) &&
			clientesRelacionadosChange?.length > 0
		) {
			const exists = clientesRelacionadosChange?.some((c) => {
				const cnpjNormalizado = c?.cnpj?.replace(/\D/g, "");
				const codigoNormalizado = c?.clienteErpId?.toString();

				return (
					(paramsSearchCliente?.typeSearch === 1 &&
						onlyNumbers === cnpjNormalizado) ||
					(paramsSearchCliente?.typeSearch === 2 &&
						onlyNumbers === codigoNormalizado)
				);
			});

			if (exists) {
				return {
					error: true,
					message: "Clientejá foi adicionado",
				};
			}
		}

		// --- 5) CNPJ inválido (menos de 14 números) ---
		if (
			errorSearch &&
			paramsSearchCliente?.typeSearch === 1 &&
			onlyNumbers.length < 14
		) {
			return {
				error: true,
				message: "CNPJ inválido",
			};
		}

		return { error: false, message: null };
	};
	const deleteclientesRelacionadosChange = (id) => {
		const newclientesRelacionadosChange = clientesRelacionadosChange?.filter(
			(c) => c?.id !== id,
		);
		setClientesRelacionadosChange(newclientesRelacionadosChange);
		setChanged(true);
	};

	const validation = getSearchValidation(
		paramsSearchCliente,
		clienteInfo,
		errorSearch,
	);

	const findCliente = async () => {
		if (
			!paramsSearchCliente?.params?.trim() ||
			!paramsSearchCliente?.typeSearch ||
			(paramsSearchCliente?.typeSearch === 1 &&
				paramsSearchCliente?.params?.trim()?.replace(/\D/g, "")?.length < 14)
		) {
			setErrorSearch(true);
			return;
		}
		if (validation.error) {
			return;
		}
		setErrorSearch(false);
		setLoadingFindClient(true);
		try {
			const response = await api.post("/find/params/cliente", {
				params: paramsSearchCliente.params,
				typeSearch: paramsSearchCliente.typeSearch,
			});
			if (!response?.data) {
				setSnackbar({
					children: "Cliente não encontrado",
					severity: "warning",
				});
				return;
			}
			setParamsSearchCliente({
				params: "",
				typeSearch: 1,
			});
			setClientesRelacionadosChange((prev) => [...prev, response?.data]);
			setChanged(true);
		} catch (error) {
			console.error(error);
			setSnackbar({
				children: "Error: Não foi possivel localizar o cliente",
				severity: "error",
			});
		} finally {
			setLoadingFindClient(false);
		}
	};

	const handleParamsChange = (value) => {
		// typeSearch = 1 → CNPJ
		if (paramsSearchCliente.typeSearch === 1) {
			// remove tudo que não for número
			let v = value.replace(/\D/g, "");

			// limita a 14 dígitos
			v = v.substring(0, 14);

			// aplica máscara de CNPJ
			v = v?.replace(/^(\d{2})(\d)/, "$1.$2");
			v = v?.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
			v = v?.replace(/\.(\d{3})(\d)/, ".$1/$2");
			v = v?.replace(/(\d{4})(\d)/, "$1-$2");

			return v;
		}

		// typeSearch = 2 → Só números
		if (paramsSearchCliente.typeSearch === 2) {
			return value.replace(/\D/g, "");
		}

		// Default (sem máscara)
		return value;
	};

	return (
		<Box sx={styles.container}>
			<Paper
				sx={styles.containerPaper}
				elevation={theme.palette.mode === "dark" ? 0 : 3}
			>
				<Typography sx={{ fontWeight: "bold", fontSize: "20px", mb: 2 }}>
					Cadastro
				</Typography>
				<Box sx={styles.content}>
					<Box sx={styles.boxForm}>
						<Grid spacing={1} container>
							<Grid item xs={12}>
								<Box sx={styles.boxSubTitle}>
									{" "}
									<ApartmentOutlined
										sx={{ color: theme.palette.primary.main }}
									/>
									<Typography variant="mySubtitle2">
										Dados empresariais
									</Typography>
								</Box>
							</Grid>
							<Grid item xs={12} sm={6}>
								<InputMask
									name="cnpj"
									mask="99.999.999/9999-99"
									value={formData?.cnpj}
									onChange={handleInputChange}
									size={"small"}
									onBlur={handleBlur}
									disabled={true}
									maskChar=" "
								>
									{(props) => (
										<TextField
											fullWidth
											label="CNPJ"
											variant="filled"
											autoComplete="off"
											sx={styles.textfield}
											disabled={true}
											{...props}
											error={Boolean(errors?.cnpj)}
											helperText={errors?.cnpj}
											onKeyDown={(event) => {
												if (event.key === "Enter") {
													event.preventDefault();
													document.getElementById("razaoSocial").focus();
												}
											}}
										/>
									)}
								</InputMask>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									fullWidth
									id="razaoSocial"
									name="razaoSocial"
									label="Razão Social"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.razaoSocial}
									onChange={handleInputChange}
									size={"small"}
									error={Boolean(errors?.razaoSocial)}
									helperText={errors?.razaoSocial}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("nomeFantasia").focus();
										}
									}}
									disabled={!editMode}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									fullWidth
									id="nomeFantasia"
									name="nomeFantasia"
									label="Nome Fantasia"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.nomeFantasia}
									onChange={handleInputChange}
									size={"small"}
									error={Boolean(errors?.nomeFantasia)}
									helperText={errors?.nomeFantasia}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("as").focus();
										}
									}}
									disabled={!editMode}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									fullWidth
									id="as"
									name="as"
									label="ASN"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.as}
									onChange={handleInputChange}
									size={"small"}
									error={Boolean(errors?.as)}
									helperText={errors?.as}
									onBlur={handleBlur}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("cep").focus();
										}
									}}
									disabled={loadingASN || !editMode}
								/>
							</Grid>
							{!clienteInfo?.isGrupoEconomico && (
								<Grid item xs={12} sm={6}>
									{editMode ? (
										<TagSelector
											type={4}
											selecaoUnica
											selectedTags={tagsProduto}
											onChange={(tags) => {
												setTagsProduto(tags);
												setChanged(true);
											}}
											title="Produto"
											subtitle="Enterprise ou BI"
										/>
									) : (
										<Box sx={styles.boxProduto}>
											<Typography variant="body2" sx={styles.labelProduto}>
												Produto
											</Typography>
											{clienteInfo?.tagsCliente?.length ? (
												clienteInfo.tagsCliente.map((tag) => (
													<TagCliente key={tag?.id} tag={tag} />
												))
											) : (
												<Typography variant="body2" sx={styles.semProduto}>
													—
												</Typography>
											)}
										</Box>
									)}
								</Grid>
							)}
							<Box sx={styles.boxDivider}>
								<Divider />
							</Box>

							<Grid item xs={12}>
								<Box sx={styles.boxSubTitle}>
									<Home sx={{ color: theme.palette.primary.main }} />
									<Typography variant="mySubtitle2">Endereço</Typography>
								</Box>
							</Grid>
							<Grid item xs={12} sm={6}>
								{editMode ? (
									<InputMask
										name="cep"
										mask="99999-999"
										value={formData?.cep}
										onChange={handleInputChange}
										size={"small"}
										onBlur={handleBlur}
										disabled={false}
										maskChar=" "
									>
										{(props) => (
											<TextField
												id="cep"
												label="CEP"
												variant="filled"
												autoComplete="off"
												sx={styles.textfield}
												{...props}
												error={Boolean(errors?.cep)}
												helperText={errors?.cep}
												InputProps={{
													endAdornment: (
														<InputAdornment position="end">
															{loadingGetCEP ? (
																<CircularProgress size={20} />
															) : (
																<></>
															)}
														</InputAdornment>
													),
												}}
											/>
										)}
									</InputMask>
								) : (
									<TextField
										id="cep"
										label="CEP"
										variant="filled"
										autoComplete="off"
										sx={styles.textfield}
										value={formData?.cep}
										error={Boolean(errors?.cep)}
										helperText={errors?.cep}
										disabled={!editMode}
										size="small"
										InputProps={{
											endAdornment: (
												<InputAdornment position="end">
													{loadingGetCEP ? (
														<CircularProgress size={20} />
													) : (
														<></>
													)}
												</InputAdornment>
											),
										}}
									/>
								)}
							</Grid>
							<Grid item xs={12} sm={6}>
								<FormControl variant="filled" sx={styles.textfield}>
									<InputLabel id="estado-label">Estado</InputLabel>
									<Select
										labelId="estado-label"
										name="estado"
										label="Estado"
										value={formData?.estado}
										defaultValue={formData?.estado}
										onChange={handleInputChange}
										size={"small"}
										error={Boolean(errors?.estado)}
										disabled={loadingGetCEP || !editMode}
									>
										{brazilianStates.map((state) => (
											<MenuItem key={state.sigla} value={state.sigla}>
												{state.nome}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									name="cidade"
									label="Cidade"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.cidade}
									onChange={handleInputChange}
									size={"small"}
									error={Boolean(errors?.cidade)}
									helperText={errors?.cidade}
									disabled={loadingGetCEP || !editMode}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("bairro").focus();
										}
									}}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								{" "}
								<TextField
									id="bairro"
									name="bairro"
									label="Bairro"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.bairro}
									onChange={handleInputChange}
									size={"small"}
									error={Boolean(errors?.bairro)}
									helperText={errors?.bairro}
									disabled={loadingGetCEP || !editMode}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("logradouro").focus();
										}
									}}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								{" "}
								<TextField
									id="logradouro"
									name="logradouro"
									label="Logradouro"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.logradouro}
									onChange={handleInputChange}
									size={"small"}
									error={Boolean(errors?.logradouro)}
									helperText={errors?.logradouro}
									disabled={loadingGetCEP || !editMode}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("numero").focus();
										}
									}}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									id="numero"
									name="numero"
									label="Número"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.numero}
									onChange={handleInputChange}
									disabled={!editMode}
									size={"small"}
									error={Boolean(errors?.numero)}
									helperText={errors?.numero}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("complemento").focus();
										}
									}}
								/>
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									disabled={!editMode}
									id="complemento"
									name="complemento"
									label="Complemento"
									variant="filled"
									autoComplete="off"
									sx={styles.textfield}
									value={formData?.complemento}
									onChange={handleInputChange}
									size={"small"}
									error={Boolean(errors?.complemento)}
									helperText={errors?.complemento}
									onKeyDown={(event) => {
										if (event.key === "Enter") {
											event.preventDefault();
											document.getElementById("telefone").focus();
										}
									}}
								/>
							</Grid>

							<Box sx={styles.boxDivider}>
								<Divider />
							</Box>
							<Grid item xs={12}>
								<Box sx={styles.boxSubTitle}>
									<Phone sx={{ color: theme.palette.primary.main }} />
									<Typography variant="mySubtitle2">Contato</Typography>
								</Box>
							</Grid>
							<Grid item xs={12} sm={6}>
								{editMode ? (
									<InputMask
										name="telefone"
										mask={
											formData?.telefone?.replace(/\s+/g, "")?.length <= 13
												? "(99) 9999-99999"
												: "(99) 99999-9999"
										}
										value={formData.telefone}
										onChange={handleInputChange}
										size={"small"}
										onBlur={handleBlur}
										disabled={false}
										maskChar=" "
									>
										{(props) => (
											<TextField
												id="telefone"
												label="Telefone"
												variant="filled"
												autoComplete="off"
												sx={styles.textfield}
												{...props}
												error={Boolean(errors?.telefone)}
												helperText={errors?.telefone}
												onKeyDown={(event) => {
													if (event.key === "Enter") {
														event.preventDefault();
														document.getElementById("email").focus();
													}
												}}
											/>
										)}
									</InputMask>
								) : (
									<TextField
										disabled={!editMode}
										size="small"
										id="telefone"
										label="Telefone"
										variant="filled"
										autoComplete="off"
										sx={styles.textfield}
										value={formData?.telefone}
										error={Boolean(errors?.telefone)}
										helperText={errors?.telefone}
										onKeyDown={(event) => {
											if (event.key === "Enter") {
												event.preventDefault();
												document.getElementById("email").focus();
											}
										}}
									/>
								)}
							</Grid>
							<Grid item xs={12} sm={6}>
								<TextField
									id="email"
									name="email"
									label="Email"
									disabled={!editMode}
									variant="filled"
									autoComplete="off"
									type="email"
									sx={styles.textfield}
									value={formData?.email}
									onChange={handleInputChange}
									size={"small"}
									onBlur={handleBlur}
									error={Boolean(errors?.email)}
									helperText={errors?.email}
								/>
							</Grid>
						</Grid>
					</Box>
				</Box>

				<Stack
					direction={"row"}
					gap={1}
					justifyContent={"flex-end"}
					width={"100%"}
					flexWrap={"wrap"}
					marginTop={2}
				>
					{editMode ? (
						<>
							<Button
								// Desfaz alterações
								onClick={() => {
									setChanged(false);
									changeEditMode();
									setFormData({
										cnpj: clienteInfo?.cnpj || "",
										razaoSocial: clienteInfo?.razaoSocial || "",
										nomeFantasia: clienteInfo?.nomeFantasia || "",
										as: clienteInfo?.as || "",
										cep: clienteInfo?.clientesCadastro?.cep || "",
										estado: clienteInfo?.clientesCadastro?.estado || "",
										cidade: clienteInfo?.clientesCadastro?.cidade || "",
										bairro: clienteInfo?.clientesCadastro?.bairro || "",
										logradouro: clienteInfo?.clientesCadastro?.logradouro || "",
										numero: clienteInfo?.clientesCadastro?.numero || "",
										complemento:
											clienteInfo?.clientesCadastro?.complemento || "",
										telefone: clienteInfo?.clientesCadastro?.telefone || "",
										email: clienteInfo?.clientesCadastro?.email || "",
										plano: clienteInfo?.clientesCadastro?.plano || "",
										diaDePagamento:
											clienteInfo?.clientesCadastro?.diaDePagamento || "",
									});
									setValues({
										valor: clienteInfo?.clientesCadastro?.valor || "",
										reajuste: clienteInfo?.clientesCadastro?.reajuste || "",
									});
									setClientesRelacionadosChange(
										clienteInfo?.ClientesRelacionados || [],
									);
									setClientesRelacionados(
										clienteInfo?.ClientesRelacionados || [],
									);
									setTagsProduto(clienteInfo?.tagsCliente || []);
									setErrors({});
								}}
								disabled={loading}
								variant="outlined"
								size="large"
								sx={{ borderRadius: "10px", height: "40px", mt: 2 }}
							>
								Cancelar
							</Button>
							<Button
								variant="contained"
								onClick={handleUpdateCadastro}
								disabled={loading}
								size="large"
								sx={{ borderRadius: "10px", height: "40px", mt: 2 }}
							>
								Salvar
							</Button>
						</>
					) : (
						<Button
							onClick={changeEditMode}
							color="primary"
							variant="contained"
							size="large"
							sx={{ mt: 2, mr: 3, borderRadius: "10px", height: "40px" }}
						>
							Editar
						</Button>
					)}
				</Stack>
			</Paper>
			{/* Modal de aviso de saída */}
			<InternoModalConfirmacaoSaida
				openConfirmacao={confirmacaoSaidaPagina}
				confirmLoad={false}
				setOpenConfirmacao={setConfirmacaoSaidaPagina}
				execute={() => {
					blocker?.proceed?.();
					setConfirmacaoSaidaPagina(false);
				}}
				cancel={() => {
					setValue(0);
					blocker?.reset();
					setConfirmacaoSaidaPagina(false);
				}}
				severity={"warning"}
				title={"Atenção"}
				contentText={
					"As alterações não salvas serão perdidas, deseja continuar?"
				}
				headerText={"Você está prestes a sair do modo de edição."}
				confirmText={"Continuar"}
			/>
		</Box>
	);
}

const brazilianStates = [
	{ nome: "Acre", sigla: "AC" },
	{ nome: "Alagoas", sigla: "AL" },
	{ nome: "Amapá", sigla: "AP" },
	{ nome: "Amazonas", sigla: "AM" },
	{ nome: "Bahia", sigla: "BA" },
	{ nome: "Ceará", sigla: "CE" },
	{ nome: "Distrito Federal", sigla: "DF" },
	{ nome: "Espírito Santo", sigla: "ES" },
	{ nome: "Goiás", sigla: "GO" },
	{ nome: "Maranhão", sigla: "MA" },
	{ nome: "Mato Grosso", sigla: "MT" },
	{ nome: "Mato Grosso do Sul", sigla: "MS" },
	{ nome: "Minas Gerais", sigla: "MG" },
	{ nome: "Pará", sigla: "PA" },
	{ nome: "Paraíba", sigla: "PB" },
	{ nome: "Paraná", sigla: "PR" },
	{ nome: "Pernambuco", sigla: "PE" },
	{ nome: "Piauí", sigla: "PI" },
	{ nome: "Rio de Janeiro", sigla: "RJ" },
	{ nome: "Rio Grande do Norte", sigla: "RN" },
	{ nome: "Rio Grande do Sul", sigla: "RS" },
	{ nome: "Rondônia", sigla: "RO" },
	{ nome: "Roraima", sigla: "RR" },
	{ nome: "Santa Catarina", sigla: "SC" },
	{ nome: "São Paulo", sigla: "SP" },
	{ nome: "Sergipe", sigla: "SE" },
	{ nome: "Tocantins", sigla: "TO" },
];
